/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_TitleInputs */



/**
* | output |
* | --- |
* | "Embed Captions" |
*
* @param {File_Export_Embed_Captions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_title = /** @type {((inputs?: File_Export_Embed_Captions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incruster les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incrustar subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションを埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन एम्बेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar legendas")
	return /** @type {LocalizedString} */ ("Embed Captions")
});